document.addEventListener("DOMContentLoaded", (event) => {
  const lazyLoadInstance = new LazyLoad();

  Fancybox.bind('[data-fancybox="gallery"]', {
    // Your custom options for a specific gallery
  });

  AOS.init({disable: 'mobile'});


  /*Риппл эффект на кнопке*/
  function createRipple(event) {
    const button = event.currentTarget;

    const circle = document.createElement("span");
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${event.clientX - button.offsetLeft - radius}px`;
    circle.style.top = `${event.clientY - button.offsetTop - radius}px`;
    circle.classList.add("ripple");

    const ripple = button.getElementsByClassName("ripple")[0];

    if (ripple) {
      ripple.remove();
    }

    button.appendChild(circle);
  }

  const buttons = document.querySelectorAll(".btnRipple");
  for (const button of buttons) {
    button.addEventListener("click", createRipple);
  }

  /*
  let tab = document.querySelectorAll('.btn-tab'),
      header = document.querySelector('.gallery-header'),
      tabContent = document.querySelectorAll('.gallery-content');

    function hideTabContent(a) {
        for (let i = a; i < tabContent.length; i++) {
            tabContent[i].classList.remove('-show');
            tabContent[i].classList.add('-hide');
        }
    }

    hideTabContent(1);

    function showTabContent(b) {
        if (tabContent[b].classList.contains('-hide')) {
            tabContent[b].classList.remove('-hide');
            tabContent[b].classList.add('-show');
        }
    }

    header.addEventListener('click', function(event) {
        let target = event.target;
        if (target && target.classList.contains('btn-tab')) {
            for(let i = 0; i < tab.length; i++) {
                if (target == tab[i]) {
                    tab.forEach((item)=>{
                      item.classList.remove('-active');
                    })
                    tab[i].classList.add('-active');
                    hideTabContent(0);
                    showTabContent(i);
                    break;
                }
            }
        }

    });
    */

  
    /*Меню*/

    const menuBtn = document.querySelectorAll('.menuBtn');
    if(menuBtn){
        menuBtn.forEach((item)=>{
            item.addEventListener('click', function(e) {
                let dataMenu = item.getAttribute("data-menu");
                let menu = document.querySelector(`#${dataMenu}`);
                document.body.classList.toggle('-overflow');
                item.closest(".header").classList.toggle('-active');
                item.classList.toggle('-active');
                menu.classList.toggle('-active');
            });
        });
    }
    
});






